import { CheckCircle2, X, XCircle } from 'lucide-react'
import { createContext, useCallback, useContext, useMemo, useState } from 'react'

const ToastContext = createContext(null)

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const dismiss = useCallback((id) => {
    setToasts((current) => current.filter((toast) => toast.id !== id))
  }, [])

  const showToast = useCallback((message, tone = 'success') => {
    const id = crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`
    setToasts((current) => [...current, { id, message, tone }])
    window.setTimeout(() => dismiss(id), 4200)
  }, [dismiss])

  const value = useMemo(() => ({ showToast }), [showToast])

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="fixed bottom-20 right-4 z-[80] flex w-[min(calc(100%-32px),380px)] flex-col gap-2 md:bottom-5" aria-live="polite" aria-atomic="true">
        {toasts.map((toast) => {
          const Icon = toast.tone === 'error' ? XCircle : CheckCircle2
          return (
            <div key={toast.id} className="surface-card flex items-start gap-3 border-line-strong p-3.5 shadow-2xl">
              <Icon className={`mt-0.5 size-5 shrink-0 ${toast.tone === 'error' ? 'text-red-400' : 'text-emerald-400'}`} aria-hidden="true" />
              <p className="min-w-0 flex-1 text-sm leading-5 text-copy-secondary">{toast.message}</p>
              <button type="button" onClick={() => dismiss(toast.id)} className="grid size-8 shrink-0 place-items-center rounded-lg text-copy-muted hover:bg-ink-800 hover:text-copy" aria-label="Tutup notifikasi">
                <X className="size-4" aria-hidden="true" />
              </button>
            </div>
          )
        })}
      </div>
    </ToastContext.Provider>
  )
}

export function useToast() {
  const context = useContext(ToastContext)
  if (!context) throw new Error('useToast harus digunakan di dalam ToastProvider')
  return context
}
